module.exports = __webpack_public_path__ + "img/USA.733bf985.png";